import {styled} from '@mui/material/styles';
import Container from '@mui/material/Container';

import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextXL,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    Card,
    FlexBLock,
    WhiteSpaceVertical,
    Dialog,
    LoadingBlock,
    Tips
} from '../../components';

import {
    useStairOrderCheck
} from '../../hook/ma/useNode'

import {
    EtherToInt,
    ShortAddress
} from '../../ethers/e'


import useCopy from '../../hook/useCopy'

function Index() {
    const {
        rootInput,
        button,
        orders
    } = useStairOrderCheck()
    const copy = useCopy()
    console.log(
        orders
    )

    // teamOrderNetTnvest: 0,
    // totalVip: 0,
    // rootRewarded: 0,
    // rootRewardedStair: 0
    return (
        <Container maxWidth="sm">
            <WhiteSpaceVertical height={20} />
            <TextXL block>Stairs Order</TextXL>
            <WhiteSpaceVertical height={20} />
            <Card>
                <TextS block>User Address</TextS>
                <Input
                    input={rootInput}
                />
                <WhiteSpace />
                <Button style={{width:'100%'}} {...button}/>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <FlexBLock>
                    <TextM>Total Node Rewarded</TextM>
                    <TextM>{EtherToInt(orders.rootRewarded)}</TextM>
                </FlexBLock>
                <FlexBLock>
                    <TextM>Total Stair Rewarded</TextM>
                    <TextM>{EtherToInt(orders.rootRewardedStair)}</TextM>
                </FlexBLock>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <FlexBLock>
                    <TextM>Net Invest</TextM>
                    <TextM>{EtherToInt(orders.totalInvet)}</TextM>
                </FlexBLock>
                <FlexBLock>
                    <TextM>Witdrawed</TextM>
                    <TextM>{EtherToInt(orders.totalWithdrawed)}</TextM>
                </FlexBLock>
                <FlexBLock>
                    <TextM>Rewarded</TextM>
                    <TextM>{EtherToInt(orders.totalRewarded)}</TextM>
                </FlexBLock>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <FlexBLock>
                    <TextM>Team Stair Net Tnvest</TextM>
                    <TextM>{EtherToInt(orders.teamOrderNetTnvest)}</TextM>
                </FlexBLock>
                <FlexBLock>
                    <TextM>Team VIP Count</TextM>
                    <TextM>{EtherToInt(orders.totalVip)}</TextM>
                </FlexBLock>
            </Card>

            <WhiteSpace />
            <Card>
                <TextM>Orders</TextM>
                <WhiteSpace />
                <LoadingBlock loading={button.loading}>
                    {
                        orders.orders.map(v => (
                            <div key={v.address} style={{paddingBottom: '8px'}}>
                                <FlexBLock onClick={() => {
                                    copy(v.address)
                                }}>
                                    <TextS>User</TextS>
                                    <TextS>{ShortAddress(v.address, 8)} | Copy</TextS>
                                </FlexBLock>
                                <FlexBLock onClick={() => {
                                    copy(v.sponsor)
                                }}>
                                    <TextS>Sponsor</TextS>
                                    <TextS>{ShortAddress(v.sponsor, 8)} | Copy</TextS>
                                </FlexBLock>
                                <FlexBLock>
                                    <TextS>Net Invest</TextS>
                                    <TextS>{EtherToInt(v.netInvest)}</TextS>
                                </FlexBLock>
                                <FlexBLock>
                                    <TextS>Witdrawed</TextS>
                                    <TextS>{EtherToInt(v.withdrawed)}</TextS>
                                </FlexBLock>
                                <FlexBLock>
                                    <TextS>Rewarded</TextS>
                                    <TextS>{EtherToInt(v.rewarded)}</TextS>
                                </FlexBLock>
                                <WhiteSpace />
                                <Hr />
                            </div>
                        ))
                    }
                </LoadingBlock>
            </Card>
        </Container>
    )
}

export default Index